import cache from './cache/index.js'
import { createPaymentAnalytics } from './paymentAnalytics.js'

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
const ENABLED_SETTING = process.env.VUE_APP_ANALYTICS_ENABLED
const ENABLED = ENABLED_SETTING === undefined
	? IS_DEVELOPMENT
	: String(ENABLED_SETTING).toLowerCase() === 'true'
const CONFIG = {
	endpoint: process.env.VUE_APP_ANALYTICS_ENDPOINT || (IS_DEVELOPMENT ? 'http://43.128.13.171/analytics/v1/batch' : ''),
	projectId: process.env.VUE_APP_ANALYTICS_PROJECT_ID || (IS_DEVELOPMENT ? 'player-analytics-test' : ''),
	writeKey: process.env.VUE_APP_ANALYTICS_WRITE_KEY || (IS_DEVELOPMENT ? 'pk_test_QsfRyx1QVDvHvblpcuIzYa6sdnHF07As' : '')
}

let initialized = false
const INTERACTION_EVENTS = new Set(['navigation_clicked', 'product_clicked', 'product_category_selected',
	'product_detail_viewed', 'login_opened', 'login_submitted', 'role_selected', 'coupon_picker_opened',
	'coupon_selected', 'payment_method_selected', 'activity_join_requested'])

function getClient() {
	if (typeof window === 'undefined') return null
	return window.PlayerAnalytics || null
}

function isConfigured() {
	return ENABLED && Boolean(CONFIG.endpoint && CONFIG.projectId && CONFIG.writeKey)
}

function warn(message, error) {
	if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
		console.warn(`[player-analytics] ${message}`, error || '')
	}
}

function call(method, ...args) {
	if (!initialized) return null
	const client = getClient()
	if (!client || typeof client[method] !== 'function') return null
	try {
		return client[method](...args)
	} catch (error) {
		warn(`${method} failed`, error)
		return null
	}
}

function buildBaseContext(context = {}) {
	return {
		site: 'meow-website-vue',
		game_code: cache.getGameCode() || null,
		...context
	}
}

const analytics = {
	init({ userId, context } = {}) {
		if (initialized) return true
		if (!isConfigured()) return false

		const client = getClient()
		if (!client || typeof client.init !== 'function') {
			warn('SDK script is unavailable')
			return false
		}

		try {
			client.init({
				endpoint: CONFIG.endpoint,
				projectId: CONFIG.projectId,
				writeKey: CONFIG.writeKey,
				environment: process.env.VUE_APP_ANALYTICS_ENVIRONMENT || process.env.NODE_ENV || 'production',
				release: process.env.VUE_APP_ANALYTICS_RELEASE || '',
				persistPlayerId: false
			})
			initialized = true
			client.setContext(buildBaseContext(context))
			if (userId) client.identify(String(userId), {
				game_code: cache.getGameCode() || null
			})
			return true
		} catch (error) {
			warn('initialization failed', error)
			return false
		}
	},

	isEnabled() {
		return initialized
	},

	track(eventName, properties = {}) {
		return call('track', eventName, { tracking_version: 'website-v2', ...properties },
			INTERACTION_EVENTS.has(eventName) ? { type: 'interaction' } : {})
	},

	identify(userId, traits = {}) {
		if (!userId) return null
		return call('identify', String(userId), {
			game_code: cache.getGameCode() || null,
			...traits
		})
	},

	clearPlayer() {
		return call('clearPlayer')
	},

	setContext(context = {}) {
		return call('setContext', buildBaseContext(context))
	},

	flush() {
		const result = call('flush')
		return result && typeof result.then === 'function' ? result : Promise.resolve(false)
	},

	getState() {
		return call('getState') || {}
	}
}

analytics.payment = createPaymentAnalytics(analytics, () => cache.getGameCode())
export default analytics
